import { Box } from '@chakra-ui/react'
import React from 'react'

const LayerComponent = () => {
  return <Box height={"80px"}></Box>
}

export default LayerComponent
